import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react'
import { FeatureDiscoveryElement } from '../types/FeatureDiscoveryElement'

interface ContextType {
  featureDiscoveryElementsOpen: FeatureDiscoveryElement[]
  setFeatureDiscoveryElementsOpen: Dispatch<SetStateAction<FeatureDiscoveryElement[]>>
  featureDiscoveryElementsAlreadyShown: FeatureDiscoveryElement[]
  setFeatureDiscoveryElementsAlreadyShown: Dispatch<SetStateAction<FeatureDiscoveryElement[]>>
  isFirstGeneratorVisit: boolean
  setIsFirstGeneratorVisit: Dispatch<SetStateAction<boolean>>
  isAnimationShowing: boolean
  setIsAnimationShowing: Dispatch<SetStateAction<boolean>>
  triggerFirstNotification: (numberOfSelectedMotifs: number) => void
}

interface Props {
  children: ReactNode
}

const Context = createContext({} as ContextType)

// The hints shown to first-time visitors
const OnboardingContext = ({ children }: Props) => {
  const [featureDiscoveryElementsOpen, setFeatureDiscoveryElementsOpen] = useState<
    FeatureDiscoveryElement[]
  >([])
  const [featureDiscoveryElementsAlreadyShown, setFeatureDiscoveryElementsAlreadyShown] = useState<
    FeatureDiscoveryElement[]
  >([])
  const [isFirstGeneratorVisit, setIsFirstGeneratorVisit] = useState<boolean>(true)
  const [isFirstNotification, setFirstNotification] = useState<boolean>(true)
  const [isAnimationShowing, setIsAnimationShowing] = useState<boolean>(false)

  const triggerFirstNotification = (numberOfSelectedMotifs: number) => {
    if (isFirstNotification && numberOfSelectedMotifs === 4) {
      setFirstNotification(false)
      setIsAnimationShowing(true)
    }
  }

  return (
    <Context.Provider
      value={{
        featureDiscoveryElementsOpen,
        setFeatureDiscoveryElementsOpen,
        featureDiscoveryElementsAlreadyShown,
        setFeatureDiscoveryElementsAlreadyShown,
        isFirstGeneratorVisit,
        setIsFirstGeneratorVisit,
        isAnimationShowing,
        setIsAnimationShowing,
        triggerFirstNotification,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useContextOnboarding = () => {
  return useContext(Context)
}

export default OnboardingContext
